<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">
  div
    div.c-auth-page__head
      h1 {{ $t('h1') }}
      h2(v-html="$t('h2', { email: email})")
    form-check-code
</template>

<script>
import { mapGetters } from 'vuex';

import formCheckCode from '../form-enter-email-code/component';

export default {
  components: {
    formCheckCode,
  },

  computed: {
    ...mapGetters('registration', ['email']),
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  margin-top: 16px;
}
</style>
